const homeRouter = {
    path: 'home',
    name: 'home',
    meta: {
      title: '首页'
    },
    component: () => import('@/pages/index/home/Home'),
    children:[]
};
export default homeRouter;


// WEBPACK FOOTER //
// ./src/router/index/home/home.js